<template>
  <div class="shipping-form">
    <div class="form-title">发货申请单</div>
    <table class="form-table" border="1" cellspacing="0" cellpadding="0">
      <tr>
        <th>公司名称</th>
        <td colspan="2">{{formData.companyName}}</td>
        <th>业务员</th>
        <td colspan="4">{{formData.salesMan}}</td>
      </tr>
      <tr>
        <th>申请原因</th>
        <td colspan="2">{{formData.applyCause}}</td>
        <th>使用设备及描述</th>
        <td colspan="4">{{formData.useDevice}}</td>
      </tr>
      
      <!-- 申请内容表格 -->
      <tr class="section-header">
        <th colspan="8">申请内容</th>
      </tr>
      <tr class="table-header">
        <th>运营商</th>
        <th>卡类型</th>
        <th class="package-region-col">套餐内容(注明配套餐出货或用户充值)/地区</th>
        <th>数量(PCS)</th>
        <th>单价(元)</th>
        <th>总金额(元)</th>
      </tr>
      <tr v-for="(content, index) in formData.contentList" :key="index" :class="'highlight-row'">
        <td>
          <template>
            <span v-if="content.operatorName=='0'">中国移动</span>
            <span v-if="content.operatorName=='1'">中国联通</span>
            <span v-if="content.operatorName=='2'">中国电信</span>
            <span v-if="content.operatorName=='3'">国际</span>
          </template>
        </td>
        <td>
          {{content.cardList.filter(t=> !!t).join(",")}}
        </td>
        <td>{{content.packageContent}}</td>
        <td>{{content.quantity}}</td>
        <td>{{content.unitPrice}}</td>
        <td>{{content.grossAmount}}</td>
      </tr>
      
      <tr>
        <th>运输方式</th>
        <td>
          <template>
            <span v-if="formData.modeOfTransport==0">自提</span>
            <span v-if="formData.modeOfTransport==1">送货</span>
            <span v-if="formData.modeOfTransport==2">快递寄付</span>
            <span v-if="formData.modeOfTransport==3">快递到付</span>
          </template>
        </td>
        <th>要求发货日期</th>
        <td colspan="5">{{formData.deliveryDate}}</td>
      </tr>
      
      <tr>
        <th>收货地址</th>
        <td colspan="7">{{formData.shippingAddress}}</td>
      </tr>
      <tr>
        <th>收货人</th>
        <td>{{formData.consignee}}</td>
        <th>收货人电话</th>
        <td colspan="5">{{formData.receivingPhone}}</td>
      </tr>
      
      <!-- 付款信息 -->
      <tr>
        <th>是否付款</th>
        <td>
            <template>
                <p>
                    <el-radio v-model="formData.whetherToPay"  label="1">是</el-radio>
                    <el-radio v-model="formData.whetherToPay"  label="0">否</el-radio>
                </p>
                <p>
                    <el-input placeholder="预计付款时间:" readonly="readonly"  prefix-icon="el-icon-date" v-model="formData.toPayDate"></el-input>
                </p>
            </template>
          <!--<template>
            <span v-if="formData.whetherToPay==1">是</span>
            <span v-if="formData.whetherToPay==0">否 <em v-if="!!formData.toPayDate">预计付款时间:{{formData.toPayDate}}</em></span>
          </template>-->
        </td>
        <th>付款方式</th>
        <td colspan="5">
          <template>
            <span v-if="formData.payMode==0">对公转账</span>
            <span v-if="formData.payMode==1">微信</span>
            <span v-if="formData.payMode==2">支付宝</span>
            <span v-if="formData.payMode==3">测试</span>
          </template>
        </td>
      </tr>
      
      <!-- 支付凭证与备注 -->
      <tr>
        <th>支付凭证或申请说明（截图）</th>
        <td colspan="7" class="left-align">
          <div class="block fixed-height-image">
            <el-image :src="formData.payVoucher" :preview-src-list="[formData.payVoucher]"></el-image>
          </div>
        </td>
      </tr>
      <tr>
        <th>备注</th>
        <td colspan="7" class="left-align">{{formData.remark}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { findShipmentRequestById } from "@/api/api.js";
export default {
  name:'Shipment',
  props: {
    shipmentId: {
      type: [Number,String]
    }
  },
  data() {
    return {
      formData:{},
    };
  },
  methods: {
    // 查找发货申请单
    initData() {
      let id = this.shipmentId;
      findShipmentRequestById({id}).then(res => {
        this.formData = res.data.data;
        this.$emit('child-event', {
          value: this.formData.shipmentNo
        });
      });
    }, 
  },
  created() {
    this.initData();
  }
};
</script>

<style scoped>
.shipping-form {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #000;
  margin-top: 20px;
}

.form-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.form-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  font-size: 14px;
  background-color: #fff;
}

.form-table th, .form-table td {
  padding: 8px 12px;
  border: 1px solid #000;
  /* 增加行高 */
  min-height: 60px; 
  box-sizing: border-box;
  background-color: #fff;
  text-align: center; 
  vertical-align: middle;
}

.section-header th {
  background-color: #fff;
  font-weight: bold;
  text-align: center; 
  padding: 10px 15px;
  font-size: 16px;
}

.table-header th {
  background-color: #fff;
  font-weight: bold;
  text-align: center;
}

.form-table th:not(.section-header th):not(.table-header th) {
  background-color: #fff;
  font-weight: bold;
  text-align: center;
  width: auto;
}

.voucher-image {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

.form-actions button {
  margin: 0 10px;
}

.package-region-col {
  width: 200px;
}

.left-align {
  text-align: left !important;
}

/* 设置高亮行背景色，这里使用 #f0f8ff 浅蓝色，可按需修改 */
.highlight-row td {
  background-color: #f0f8ff;
}

/* 设置固定高度，这里设置为 200px，可按需调整 */
.fixed-height-image {
  height: 150px;
}

.fixed-height-image .el-image {
  width: 50%;
  height: 100%;
  object-fit: contain; /* 确保图片完整显示在容器内 */
}

</style>